export type MasteryPlan = { intervalsDays: number[] };

export const defaultMasteryPlan: MasteryPlan = {
  intervalsDays: [0, 1, 2, 4, 8],
};
export const classRecommendedMasteryPlan: MasteryPlan = {
  intervalsDays: [0, 2, 4],
};
export const maximumMasteryIntervalDays = 36500;

export function defaultMasteryIntervalDays(index: number): number | undefined {
  const days = index === 0 ? 0 : 2 ** (index - 1);
  return days <= maximumMasteryIntervalDays ? days : undefined;
}

export function parseMasteryPlan(input: unknown): MasteryPlan {
  if (!input || typeof input !== "object" || Array.isArray(input))
    throw new Error("マスターまでの達成目標を設定してください。");
  const value = input as Record<string, unknown>;
  const intervals = value.intervalsDays;
  if (
    Object.keys(value).some((key) => key !== "intervalsDays") ||
    !Array.isArray(intervals) ||
    intervals.length < 1 ||
    intervals.length > 1000 ||
    intervals[0] !== 0 ||
    intervals.some(
      (days) =>
        !Number.isInteger(days) ||
        days < 0 ||
        days > maximumMasteryIntervalDays,
    )
  )
    throw new Error(
      `達成目標は1〜1000回、間隔は0〜${maximumMasteryIntervalDays}日の整数で設定してください。初回は当日です。`,
    );
  return { intervalsDays: [...intervals] };
}

// Dates represent calendar days in Japan; intervals start at the actual
// completion date, even when a practice happens earlier or later than planned.
export function masteryProgress(
  plan: MasteryPlan,
  completedCount: number,
  lastCompletedAt: Date | null,
  now = new Date(),
) {
  const targetCount = plan.intervalsDays.length;
  const mastered = completedCount >= targetCount;
  let nextReviewOn: string | null = null;
  if (!mastered) {
    const day = new Date(
      (lastCompletedAt ?? now).getTime() + 9 * 60 * 60 * 1000,
    )
      .toISOString()
      .slice(0, 10);
    const next = new Date(`${day}T00:00:00Z`);
    next.setUTCDate(
      next.getUTCDate() +
        (lastCompletedAt ? (plan.intervalsDays[completedCount] ?? 0) : 0),
    );
    nextReviewOn = next.toISOString().slice(0, 10);
  }
  return { completedCount, targetCount, mastered, nextReviewOn };
}
